import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { logger } from '../../lib/logger';

export const useCrossAgencyDashboard = ({ isAzaiStaff, timeRange }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadStats = useCallback(async () => {
    setLoading(true);
    try {
      // timeRange is reserved for future server-side filtering — not wired
      // yet, but kept in deps so the hook re-fetches when the selector
      // changes (matches the previous component behavior).
      const response = await api.get('/agencies/stats/cross-agency');
      setStats(response.data);
    } catch (error) {
      logger.error('Failed to load cross-agency stats:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isAzaiStaff) {
      loadStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- timeRange triggers refetch
  }, [isAzaiStaff, timeRange]);

  return { stats, loading, refresh: loadStats };
};
